// extracted by mini-css-extract-plugin
module.exports = {"suppress_entities":"SuppressEntities_suppress_entities__2M6NW"};